"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityContent = void 0;
const adapters_1 = require("../../adapters");
class CommunityContent {
    url;
    headers;
    constructor(url, headers) {
        this.url = url;
        this.headers = headers;
    }
    /**
     * Returns community content.
     * @param mediaFilter The type of media to get
     * @param page Zero based page
     * @param sort The sort mode.
     * @returns Returns community content.
     */
    GetCommunityContent(mediaFilter, page, sort, tokens) {
        const requestURL = `${this.url}/CommunityContent/Get/${sort}/${mediaFilter}/${page}/`;
        const authHeaders = (0, adapters_1.parseAuthenticationHeaders)(this.headers, tokens);
        return (0, adapters_1.request)(requestURL, true, "GET", authHeaders);
    }
}
exports.CommunityContent = CommunityContent;
